const validateZipCode = (zip) => {
    const regex = /^\d{5}$/; // Valid US zip code (5 digits)
    return regex.test(zip);
};

export default validateZipCode;
